import type { Movie } from "@/types/cinema";

export const movies: Movie[] = [
  {
    id: "m01",
    title: "星际远征",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%2C%20lone%20astronaut%20standing%20before%20a%20giant%20spaceship%2C%20deep%20space%20nebula%20background%2C%20dramatic%20deep%20blue%20and%20amber%20lighting%2C%20minimal%20composition%2C%20high%20detail%2C%20moody%20atmosphere&width=600&height=900&seq=cinema-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20film%20key%20art%2C%20vast%20deep%20space%20nebula%20with%20a%20distant%20spaceship%2C%20deep%20blue%20tones%20with%20warm%20amber%20accents%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20wide%20banner%20composition&width=1600&height=900&seq=cinema-hero-01&orientation=landscape",
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-10-01",
    duration: 142,
    director: "陈墨白",
    cast: ["李承宇", "周知夏", "王砚辉", "林海"],
    rating: 9.1,
    synopsis:
      "人类首次载人深空远征任务在抵达目标星系前夕遭遇不明引力异常，船员们必须在有限的时间里解开谜题，决定全人类的命运。",
    status: "now",
    language: "国语",
    formats: ["2D", "IMAX", "CINITY"],
    heat: 98,
  },
  {
    id: "m02",
    title: "长安万里",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20historical%20chinese%20animation%20movie%20poster%2C%20ancient%20tang%20dynasty%20cityscape%20at%20dusk%2C%20ink%20painting%20style%20with%20golden%20lanterns%2C%20deep%20blue%20night%20sky%2C%20dramatic%20warm%20accent%20lighting%2C%20minimal%20poster%20composition&width=600&height=900&seq=cinema-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20city%20panorama%20at%20night%2C%20ink%20wash%20painting%20style%2C%20glowing%20lanterns%20and%20palaces%2C%20deep%20blue%20sky%20with%20warm%20golden%20highlights%2C%20cinematic%20wide%20banner%20for%20historical%20animation%20film&width=1600&height=900&seq=cinema-hero-02&orientation=landscape",
    genres: ["动画", "历史"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-09-28",
    duration: 168,
    director: "鞠明远",
    cast: ["杨天翔", "季冠霖", "宝木中阳"],
    rating: 9.4,
    synopsis:
      "一部以盛唐为背景的水墨动画史诗，讲述少年诗人在乱世中追寻家国理想与友情的故事，画面如画卷般徐徐展开。",
    status: "now",
    language: "国语",
    formats: ["2D", "IMAX"],
    heat: 95,
  },
  {
    id: "m03",
    title: "深海回响",
    poster:
      "https://readdy.ai/api/search-image?query=suspense%20thriller%20movie%20poster%2C%20lone%20diver%20in%20dark%20deep%20ocean%20with%20a%20beam%20of%20light%2C%20deep%20blue%20underwater%20atmosphere%2C%20ominous%20mood%2C%20minimal%20composition%2C%20cinematic%20high%20detail&width=600&height=900&seq=cinema-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20underwater%20cinematic%20scene%2C%20dark%20blue%20water%20with%20a%20single%20beam%20of%20light%20from%20above%2C%20mysterious%20abyss%20atmosphere%2C%20suspenseful%20wide%20film%20banner&width=1600&height=900&seq=cinema-hero-03&orientation=landscape",
    genres: ["悬疑", "惊悚"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-10-10",
    duration: 118,
    director: "苏景行",
    cast: ["黄觉", "倪妮", "张宥浩"],
    rating: 8.6,
    synopsis:
      "一支科研深潜队在马里亚纳海沟底捕获到一段无法解释的低频回响，随着调查深入，他们发现自己并不是这片深海里唯一的访客。",
    status: "now",
    language: "国语",
    formats: ["2D", "Dolby Cinema"],
    heat: 88,
  },
  {
    id: "m04",
    title: "城市之光",
    poster:
      "https://readdy.ai/api/search-image?query=urban%20drama%20movie%20poster%2C%20lonely%20figure%20walking%20through%20a%20rainy%20modern%20city%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20street%20lights%2C%20reflective%20wet%20streets%2C%20cinematic%20minimal%20composition&width=600&height=900&seq=cinema-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20night%20in%20the%20rain%2C%20deep%20blue%20atmosphere%20with%20warm%20orange%20street%20lights%2C%20reflections%20on%20wet%20asphalt%2C%20cinematic%20wide%20banner%2C%20urban%20drama&width=1600&height=900&seq=cinema-hero-04&orientation=landscape",
    genres: ["剧情", "爱情"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-09-20",
    duration: 126,
    director: "许安宁",
    cast: ["张子枫", "刘昊然", "咏梅"],
    rating: 8.9,
    synopsis:
      "深夜便利店店员与一位总在凌晨出现的顾客，在一座不眠都市里互相治愈，也重新找回了各自生活的光。",
    status: "now",
    language: "国语",
    formats: ["2D"],
    heat: 84,
  },
  {
    id: "m05",
    title: "追风者",
    poster:
      "https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20poster%2C%20race%20car%20speeding%20through%20a%20neon%20lit%20city%20at%20night%2C%20motion%20blur%2C%20deep%20blue%20and%20orange%20lighting%2C%20dynamic%20angle%2C%20cinematic%20high%20detail&width=600&height=900&seq=cinema-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=action%20film%20key%20art%2C%20supercar%20drifting%20on%20a%20night%20highway%20with%20city%20lights%2C%20light%20trails%20and%20motion%20blur%2C%20deep%20blue%20and%20orange%20cinematic%20grade%2C%20wide%20banner&width=1600&height=900&seq=cinema-hero-05&orientation=landscape",
    genres: ["动作", "犯罪"],
    region: "美国",
    year: 2026,
    releaseDate: "2026-10-05",
    duration: 134,
    director: "Marcus Reid",
    cast: ["Chris Dawson", "Elena Park", "李冰冰"],
    rating: 8.3,
    synopsis:
      "一名退役赛车手被迫重返地下竞速世界，为救回被绑架的弟弟而卷入一场横跨整座城市的极速追逐。",
    status: "now",
    language: "英语",
    formats: ["2D", "IMAX", "杜比全景声"],
    heat: 90,
  },
  {
    id: "m06",
    title: "时光代理人",
    poster:
      "https://readdy.ai/api/search-image?query=science%20fiction%20romance%20movie%20poster%2C%20two%20silhouettes%20against%20a%20glowing%20clock%20portal%2C%20deep%20blue%20tones%20with%20warm%20amber%20glow%2C%20dreamy%20atmosphere%2C%20cinematic%20minimal%20composition&width=600&height=900&seq=cinema-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=surreal%20time%20travel%20scene%2C%20glowing%20circular%20portal%20with%20floating%20clock%20fragments%2C%20deep%20blue%20cosmos%20with%20warm%20amber%20light%20rays%2C%20dreamy%20cinematic%20wide%20banner&width=1600&height=900&seq=cinema-hero-06&orientation=landscape",
    genres: ["科幻", "爱情"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-10-12",
    duration: 121,
    director: "白清和",
    cast: ["屈楚萧", "周也", "陈数"],
    rating: 8.7,
    synopsis:
      "一家能替人回到过去完成心愿的神秘事务所里，年轻的代理人在一次又一次的委托中，逐渐走近自己无法挽回的那段时光。",
    status: "now",
    language: "国语",
    formats: ["2D", "CINITY"],
    heat: 86,
  },
  {
    id: "m07",
    title: "雪山救援",
    poster:
      "https://readdy.ai/api/search-image?query=adventure%20movie%20poster%2C%20tiny%20climbers%20on%20a%20snow%20covered%20mountain%20peak%20at%20dawn%2C%20deep%20blue%20shadows%20with%20warm%20orange%20sunrise%20light%2C%20epic%20scale%2C%20cinematic%20minimal%20composition&width=600&height=900&seq=cinema-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20snow%20mountain%20range%20at%20sunrise%2C%20deep%20blue%20shadows%20and%20warm%20orange%20light%20on%20the%20peaks%2C%20vast%20cinematic%20landscape%20for%20adventure%20film%2C%20wide%20banner&width=1600&height=900&seq=cinema-hero-07&orientation=landscape",
    genres: ["冒险", "剧情"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-10-18",
    duration: 129,
    director: "范天成",
    cast: ["吴京", "张译", "李沁"],
    rating: 8.8,
    synopsis:
      "一场突如其来的雪崩困住了登山队，退役救援队员在极端天气中与时间赛跑，展开一场惊心动魄的高海拔营救。",
    status: "now",
    language: "国语",
    formats: ["2D", "IMAX"],
    heat: 82,
  },
  {
    id: "m08",
    title: "暗夜行者",
    poster:
      "https://readdy.ai/api/search-image?query=crime%20noir%20movie%20poster%2C%20silhouette%20of%20a%20detective%20in%20a%20dark%20alley%20lit%20by%20a%20single%20street%20lamp%2C%20deep%20blue%20shadows%20with%20orange%20glow%2C%20moody%20atmosphere%2C%20cinematic%20minimal%20composition&width=600&height=900&seq=cinema-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20noir%20city%20alley%20at%20night%2C%20deep%20blue%20shadows%20with%20warm%20orange%20lamp%20glow%2C%20reflective%20wet%20ground%2C%20mysterious%20cinematic%20wide%20banner%2C%20crime%20film&width=1600&height=900&seq=cinema-hero-08&orientation=landscape",
    genres: ["犯罪", "悬疑"],
    region: "中国香港",
    year: 2026,
    releaseDate: "2026-11-06",
    duration: 115,
    director: "杜思远",
    cast: ["古天乐", "刘青云", "张钧甯"],
    rating: 8.5,
    synopsis:
      "一名游走于黑白之间的卧底警探，在案件与身份的双重压力下，必须在天亮之前找出真正的幕后黑手。",
    status: "upcoming",
    language: "粤语",
    formats: ["2D", "Dolby Cinema"],
    heat: 76,
  },
  {
    id: "m09",
    title: "春日告白",
    poster:
      "https://readdy.ai/api/search-image?query=sweet%20romance%20movie%20poster%2C%20young%20couple%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pastel%20tones%20with%20warm%20orange%20sunlight%2C%20dreamy%20bokeh%2C%20minimal%20cinematic%20composition&width=600&height=900&seq=cinema-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=spring%20cherry%20blossom%20avenue%20in%20bloom%2C%20soft%20warm%20sunlight%20filtering%20through%20petals%2C%20dreamy%20pastel%20cinematic%20romance%20wide%20banner%2C%20gentle%20atmosphere&width=1600&height=900&seq=cinema-hero-09&orientation=landscape",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2026,
    releaseDate: "2026-11-14",
    duration: 108,
    director: "岩井俊介",
    cast: ["广濑铃", "山崎贤人", "松隆子"],
    rating: 8.4,
    synopsis:
      "在樱花盛开的小镇上，一封没有寄出的信让两个错过多年的年轻人再次相遇，重写那段未完成的青春告白。",
    status: "upcoming",
    language: "日语",
    formats: ["2D"],
    heat: 72,
  },
  {
    id: "m10",
    title: "无声证词",
    poster:
      "https://readdy.ai/api/search-image?query=tense%20suspense%20movie%20poster%2C%20courtroom%20spotlight%20on%20an%20empty%20witness%20stand%2C%20deep%20blue%20shadows%20with%20a%20thin%20orange%20light%20edge%2C%20minimal%20dramatic%20composition%2C%20cinematic&width=600&height=900&seq=cinema-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=moody%20courtroom%20interior%20with%20dramatic%20spotlight%2C%20deep%20blue%20shadows%20and%20a%20warm%20orange%20light%20edge%2C%20empty%20and%20tense%20atmosphere%2C%20cinematic%20wide%20banner%20suspense%20film&width=1600&height=900&seq=cinema-hero-10&orientation=landscape",
    genres: ["悬疑", "剧情"],
    region: "韩国",
    year: 2026,
    releaseDate: "2026-11-21",
    duration: 132,
    director: "Park Joon-ho",
    cast: ["Song Hye-kyo", "Lee Do-hyun", "Kim Nam-gil"],
    rating: 8.9,
    synopsis:
      "一桩证据链完整的谋杀案在开庭前夜出现了唯一的目击者，然而这名证人却始终沉默不语，真相在无声中逐渐浮现。",
    status: "upcoming",
    language: "韩语",
    formats: ["2D"],
    heat: 74,
  },
  {
    id: "m11",
    title: "熊猫计划",
    poster:
      "https://readdy.ai/api/search-image?query=family%20animation%20movie%20poster%2C%20cute%20cartoon%20panda%20on%20an%20adventure%20in%20a%20green%20bamboo%20forest%2C%20warm%20orange%20sunlight%2C%20bright%20friendly%20colors%2C%20minimal%20cinematic%20composition&width=600&height=900&seq=cinema-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=colorful%20lush%20bamboo%20forest%20with%20warm%20sunlight%2C%20bright%20friendly%20animation%20style%2C%20playful%20and%20cheerful%20atmosphere%2C%20cinematic%20wide%20family%20film%20banner&width=1600&height=900&seq=cinema-hero-11&orientation=landscape",
    genres: ["动画", "喜剧"],
    region: "中国大陆",
    year: 2026,
    releaseDate: "2026-12-05",
    duration: 96,
    director: "赵一鸣",
    cast: ["沈腾", "张小斐", "贾冰"],
    rating: 8.2,
    synopsis:
      "一只意外走失的熊猫幼崽与三个性格迥异的护林员组成临时小队，踏上了一场笑料百出又温暖人心的回家之旅。",
    status: "upcoming",
    language: "国语",
    formats: ["2D", "3D"],
    heat: 70,
  },
  {
    id: "m12",
    title: "末日边缘",
    poster:
      "https://readdy.ai/api/search-image?query=apocalyptic%20disaster%20movie%20poster%2C%20vast%20storm%20swallowing%20a%20city%20skyline%2C%20deep%20blue%20tempest%20with%20orange%20fire%20glow%20on%20the%20horizon%2C%20epic%20dramatic%20scale%2C%20cinematic%20minimal%20composition&width=600&height=900&seq=cinema-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=apocalyptic%20superstorm%20over%20a%20modern%20city%2C%20deep%20blue%20turbulent%20clouds%20with%20warm%20orange%20fire%20glow%2C%20epic%20cinematic%20disaster%20wide%20banner%2C%20dramatic%20scale&width=1600&height=900&seq=cinema-hero-12&orientation=landscape",
    genres: ["科幻", "灾难"],
    region: "美国",
    year: 2026,
    releaseDate: "2026-12-18",
    duration: 148,
    director: "James Weller",
    cast: ["Tom Hardy", "Jessica Chastain", "王传君"],
    rating: 8.6,
    synopsis:
      "当一场史无前例的行星级风暴逼近地球，一支科学家小队必须在世界沉没之前，启动最后的方舟计划。",
    status: "upcoming",
    language: "英语",
    formats: ["2D", "IMAX", "杜比全景声"],
    heat: 80,
  },
];